<template>
  <div>
    <div :class="$style.name">{{ message.payload.name }}</div>
    <a :href="`tel:${message.payload.phone}`">
      {{ message.payload.phone }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'message-content-contact',
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>

<style module lang="scss">
.name {
  font-weight: 500;
}
</style>
